export default "__VITE_ASSET__BLvCxhhI__"